export default __webpack_public_path__ + "locales/es/Settings.json?hash=5a145b4a108490455d5f058ad3d88096";